export enum InputContentType {
  TITLE = 'title',
  BODY = 'body',
  SUBTITLE = 'subTitle',
  FOOTNOTE = 'footNote',
}
